import axiosInstance from "./axiosInstance";

export const loginUser = async (username, password) => {
  const response = await axiosInstance.post("/user/login", {
    username,
    password,
  });
  return response.data;
};

export const signupUser = async (name, email, password, username, phone) => {
 
  const response = await axiosInstance.post("/user/signup", {
    name,
    email,
    password,
    username,
    phone,
    role:"student"
  });
  return response.data;
};

export const confirmUser = async (username,code)=> {
  const response = await axiosInstance.post("user/confirmuser",{
    username,
    code
  })
  return response.data;
}

export const checkEmailExists = async(email)=>{
  console.log(email, "checking")
  const response = await axiosInstance.post("/user/getUserByEmail",{
    email
  })
  console.log(response.data)
   return response.data
}

export const checkUserExists = async(username)=>{
  console.log(username, "checking")
  const response = await axiosInstance.post("/user/getUserByUser",{
    username
  })
  console.log(response.data)
   return response.data
}

export const forgotPassword= async(email)=>{
  console.log(email,"email")
  const response = await axiosInstance.post("/user/forgotpassword",{
    email
  })
  return response.data;
}

export const resetPassword= async(username,code,newPassword)=>{
  console.log(username,code,newPassword,"resetpassword")
  const response = await axiosInstance.post("/user/resetpassword",{
    username,
    code,
    newPassword
  })
  return response.data;
}

export const logoutUser = async () => {
  const response = await axiosInstance.post("/user/logout");
  return response.data;
};

export const getUserProfile = async (email) => {
  const res = await axiosInstance.get(`user/getprofile?email=${email}`);
  return res.data;
};

export const userProfile = async (formData) => {
  const response = await axiosInstance.post(
    "/user/saveprofile",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};

export const getBanner = async () => {
  const res = await axiosInstance.get("admin/getbanner");
  return res.data;
};



